"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessListUnWhitelistDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_query_1 = require("@tanstack/react-query");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_confirmation_1 = require("@dzambalaorg/mui-dialog-confirmation");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const unWhitelist_json_1 = __importDefault(require("@framework/abis/json/ERC20Whitelist/unWhitelist.json"));
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const AccessListUnWhitelistDialog = (props) => {
    const { data, open, onCancel, ...rest } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { data: rows = [], isLoading } = (0, react_query_1.useQuery)({
        queryKey: [`/access-list/${data.address}`],
        queryFn: () => {
            return api.fetchJson({
                url: `/access-list/${data.address}`,
                method: "GET",
            });
        },
        enabled: open,
    });
    const { execute: metaUnWhitelist } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: data.address,
            abi: unWhitelist_json_1.default,
            functionName: "unWhitelist",
            args: [values.account],
        });
    });
    const handleUnWhitelist = (values) => {
        return async () => {
            await metaUnWhitelist(values).finally(onCancel);
        };
    };
    return ((0, jsx_runtime_1.jsx)(mui_dialog_confirmation_1.ConfirmationDialog, { open: open, onCancel: onCancel, message: "dialogs.unWhitelist", "data-testid": "AccessListUnWhitelistDialog", ...rest, children: (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(access => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: access.account }), (0, jsx_runtime_1.jsx)(styled_1.ListActions, { children: (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUnWhitelist(access), message: "dialogs.unWhitelist", icon: icons_material_1.Delete }) })] }, access.id))) }) }) }));
};
exports.AccessListUnWhitelistDialog = AccessListUnWhitelistDialog;
//# sourceMappingURL=index.js.map